import { createEmojiIcon } from '../EmojiIcon';

export const LocationOnIcon = createEmojiIcon('📍');
export const PersonIcon = createEmojiIcon('👤');
export const PersonOutlineIcon = createEmojiIcon('👤');
export const ScheduleIcon = createEmojiIcon('🕐');
export const AccessTimeIcon = createEmojiIcon('🕐');
export const TodayIcon = createEmojiIcon('📅');
export const AttachMoneyIcon = createEmojiIcon('💰');
export const DescriptionIcon = createEmojiIcon('📄');
export const CalendarTodayIcon = createEmojiIcon('📅');
export const EventIcon = createEmojiIcon('📅');
export const NotificationImportantIcon = createEmojiIcon('🔔');
export const PhoneIcon = createEmojiIcon('📞');
export const SmsIcon = createEmojiIcon('💬');
export const EmailIcon = createEmojiIcon('✉️');
export const NavigationIcon = createEmojiIcon('🧭');
export const DirectionsIcon = createEmojiIcon('🧭');
export const RouteIcon = createEmojiIcon('🛣️');
export const LockIcon = createEmojiIcon('🔒');
export const LockOpenIcon = createEmojiIcon('🔓');
export const StarIcon = createEmojiIcon('⭐');
export const VideoCameraFrontIcon = createEmojiIcon('📹');
export const CameraFrontIcon = createEmojiIcon('📹');
export const AddLocationAltIcon = createEmojiIcon('📍');
export const PlaceIcon = createEmojiIcon('📍');
export const OpenInNewIcon = createEmojiIcon('↗️');
export const ContentPasteIcon = createEmojiIcon('📋');
export const FormatListBulletedIcon = createEmojiIcon('📋');
export const ListAltIcon = createEmojiIcon('📋');
export const DragIndicatorIcon = createEmojiIcon('⠿');
export const PasswordIcon = createEmojiIcon('🔑');
export const LocalShippingIcon = createEmojiIcon('🚚');
export const SquareFootIcon = createEmojiIcon('📐');
export const TrendingUpIcon = createEmojiIcon('📈');
export const TrendingDownIcon = createEmojiIcon('📉');
export const SensorsIcon = createEmojiIcon('📡');
export const ManageSearchIcon = createEmojiIcon('🔎');
export const ReportProblemRoundedIcon = createEmojiIcon('⚠️');
export const DesktopWindowsIcon = createEmojiIcon('🖥️');
export const MapOutlinedIcon = createEmojiIcon('🗺️');
